export type NameStepArm = 'control' | 'no_name';
export function reportableExperimentRunId(consent:'accepted'|'rejected'|null,runId:string|null):string|null {
  return consent==='accepted' && typeof runId==='string' && /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/iu.test(runId) ? runId : null;
}
type ArmStore = Pick<Storage,'getItem'|'setItem'>;
const key = 'focuscorp_name_step_arm_v1';

export function readNameStepArm(store:ArmStore, namespace='live'):NameStepArm|null {
  try {
    const arm=store.getItem(`${key}:${namespace}`);
    return arm==='control'||arm==='no_name'?arm:null;
  } catch { return null; }
}

export async function assignNameStepArm(options:{
  store:ArmStore; readPercent:()=>Promise<number>; random:()=>number;
  legacyPlan?:boolean; override?:string|null; allowOverride?:boolean; namespace?:string;
}):Promise<NameStepArm> {
  const namespace=options.namespace??'live';
  try {
    // A blocked store cannot preserve a treatment through payment or OAuth.
    const existing=readNameStepArm(options.store,namespace);
    if(options.allowOverride&&(options.override==='control'||options.override==='no_name')){
      options.store.setItem(`${key}:${namespace}`,options.override);
      return options.override;
    }
    if(existing)return existing;
    const percent=options.legacyPlan?0:await options.readPercent();
    const arm:NameStepArm=Number.isInteger(percent)&&percent>=0&&percent<=100&&options.random()<percent/100?'no_name':'control';
    options.store.setItem(`${key}:${namespace}`,arm);
    return arm;
  } catch { return 'control'; }
}

export async function fetchNameStepPercent(url:string,anonKey:string,fetcher:typeof fetch=fetch):Promise<number> {
  const endpoint=`${url.replace(/\/$/u,'')}/rest/v1/web_funnel_experiment_config?select=treatment_percent&id=eq.name_step`;
  const response=await fetcher(endpoint,{headers:{apikey:anonKey,Authorization:`Bearer ${anonKey}`},cache:'no-store',signal:AbortSignal.timeout(1500)});
  if(!response.ok)throw Error('Name-step setting unavailable');
  const rows=await response.json();
  if(!Array.isArray(rows)||rows.length!==1||!Number.isInteger(rows[0]?.treatment_percent))throw Error('Name-step setting invalid');
  return rows[0].treatment_percent;
}

export async function fetchLocalNameStepPercent(fetcher:typeof fetch=fetch):Promise<number> {
  try {
    const response=await fetcher('http://127.0.0.1:4178/__name-step/config',{cache:'no-store',signal:AbortSignal.timeout(500)});
    if (!response.ok) return 50;
    const value=(await response.json()).treatment_percent;
    return Number.isInteger(value)&&value>=0&&value<=100?value:50;
  } catch { return 50; }
}
